(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
(function () {
  var header = document.querySelector('[data-header]');
  if (!header) return;
  var onScroll = function () {
    header.classList.toggle('is-scrolled', window.scrollY > 40);
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  var toggle = document.getElementById('NavToggle');
  var nav = document.getElementById('SiteNav');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var isOpen = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
    nav.querySelectorAll('.nav__link').forEach(function (link) {
      link.addEventListener('click', function () {
        nav.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
      });
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
(function () {
  var select = document.querySelector('[data-sort-select]');
  if (!select) return;
  select.addEventListener('change', function () { select.form.submit(); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
(function () {
  var root = document.querySelector('[data-product-root]');
  if (!root) return;

  var variantInput = root.querySelector('[data-variant-id-input]');
  var priceEl = root.querySelector('[data-product-price]');
  var submitBtn = root.querySelector('[data-product-submit]');
  var radios = root.querySelectorAll('[data-variant-radio]');
  var variants = JSON.parse(root.dataset.variants || '[]');
  var cartAddUrl = root.dataset.cartAddUrl;
  var i18nAddToCart = root.dataset.i18nAddToCart || 'In den Warenkorb';
  var i18nSoldOut = root.dataset.i18nSoldOut || 'Ausverkauft';
  var i18nUnavailable = root.dataset.i18nUnavailable || 'Nicht verfügbar';

  radios.forEach(function (radio) {
    radio.addEventListener('change', function () {
      var variant = variants.filter(function (v) { return v.id.toString() === radio.value; })[0];
      if (!variant) return;
      variantInput.value = variant.id;
      if (priceEl) priceEl.textContent = Theme.formatMoney(variant.price);
      submitBtn.disabled = !variant.available;
      var label = submitBtn.querySelector('[data-add-to-cart-text]');
      if (label) {
        label.textContent = variant.available ? i18nAddToCart : i18nSoldOut;
      }
      root.querySelectorAll('.variant-pill').forEach(function (p) { p.classList.remove('is-selected'); });
      var pill = radio.closest('.variant-pill');
      if (pill) pill.classList.add('is-selected');
    });
  });

  var form = root.querySelector('[data-product-form]');
  var message = root.querySelector('[data-product-form-message]');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      submitBtn.disabled = true;
      var formData = new FormData(form);
      fetch(cartAddUrl, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          submitBtn.disabled = false;
          if (data.status) {
            if (message) message.textContent = data.description || i18nUnavailable;
            return;
          }
          if (message) message.textContent = '';
          document.dispatchEvent(new CustomEvent('cart:updated'));
        })
        .catch(function () {
          submitBtn.disabled = false;
          if (message) message.textContent = i18nUnavailable;
        });
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
(function () {
  var input = document.querySelector('[data-search-input]');
  var box = document.querySelector('[data-search-suggest]');
  if (!input || !box) return;
  var timer;

  input.addEventListener('input', function () {
    clearTimeout(timer);
    var q = input.value.trim();
    if (q.length < 2) { box.hidden = true; box.innerHTML = ''; return; }
    timer = setTimeout(function () {
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=5&section_id=predictive-search')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          if (!products.length) { box.hidden = true; box.innerHTML = ''; return; }
          box.innerHTML = products.map(function (p) {
            return '<a href="' + p.url + '" class="search-suggest__item"><span>' + p.title + '</span><span>' + p.price + '</span></a>';
          }).join('');
          box.hidden = false;
        })
        .catch(function () { box.hidden = true; });
    }, 220);
  });

  document.addEventListener('click', function (e) {
    if (!box.contains(e.target) && e.target !== input) box.hidden = true;
  });
})();

  } catch(e) { console.error(e); }
})();
})();
